import React from "react";
import { Stack, TextField } from "@mui/material";

type Props = {
  commitMsg: string;
  setCommitMsg: (v: string) => void;
  publishMode: "prod" | "preview";
  setPublishMode: (v: "prod" | "preview") => void;
  branchName: string;
  setBranchName: (v: string) => void;
  branchPlaceholder?: string;
};

const PublishBar: React.FC<Props> = ({
  commitMsg,
  setCommitMsg,
  publishMode,
  setPublishMode,
  branchName,
  setBranchName,
  branchPlaceholder,
}) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1}
      sx={{ mr: 1, flex: 1, alignItems: "center", justifyContent: "flex-end" }}
    >
      <TextField
        size="small"
        label="Commit Mesajı"
        value={commitMsg}
        onChange={(e) => setCommitMsg(e.target.value)}
      />
      <TextField
        size="small"
        label="Yayın Modu"
        select
        SelectProps={{ native: true }}
        value={publishMode}
        onChange={(e) => setPublishMode(e.target.value as any)}
        sx={{ minWidth: 140 }}
      >
        <option value="prod">Prod</option>
        <option value="preview">Preview PR</option>
      </TextField>
      {publishMode === "preview" && (
        <TextField
          size="small"
          label="Branch"
          value={branchName}
          onChange={(e) => setBranchName(e.target.value)}
          placeholder={branchPlaceholder || "preview/changes"}
        />
      )}
    </Stack>
  );
};

export default PublishBar;
